import { motion } from "framer-motion";
import { Users, TrendingUp, MessageCircle, Activity } from "lucide-react";

const StatCard = ({ icon: Icon, label, value, suffix, i }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: i * 0.06 }}
    className="bg-white border-2 border-[rgba(10,10,10,0.1)] p-5"
  >
    <div className="flex items-center justify-between mb-3">
      <span className="av-label">{label}</span>
      <Icon className="h-4 w-4 text-conversion" />
    </div>
    <div className="font-data text-3xl font-bold text-obsidian">
      {value}<span className="text-lg text-neutral-400">{suffix}</span>
    </div>
  </motion.div>
);

export const StatCards = ({ stats }) => {
  if (!stats) return null;
  const cards = [
    { icon: Users, label: "Total Leads", value: stats.total_leads, suffix: "" },
    { icon: Activity, label: "Tests Run", value: stats.total_analyses, suffix: "" },
    { icon: TrendingUp, label: "Conversion Rate", value: stats.conversion_rate, suffix: "%" },
    { icon: MessageCircle, label: "WhatsApp Delivery", value: stats.delivery_rate, suffix: "%" },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="admin-stats">
      {cards.map((c, i) => <StatCard key={c.label} {...c} i={i} />)}
    </div>
  );
};

export default StatCards;
